import { combineDucks } from "../helpers/combineDucks";
import createItemFetcher from "../helpers/item";
import { createUseFetch } from "../helpers/fetchHooks";
const availableCardsUrlCompute = config => {
    const { scenario } = config;
    return `/api/v1/cards/${scenario}/available`;
};
const detailedCardsUrlCompute = config => {
    const { scenario, workspace, id } = config;
    return `/api/v1/cards/${scenario}/${workspace}/status/${id}`;
};
const computeCardsId = config => {
    const { scenario, workspace } = config;
    return `${scenario}_${workspace}`;
};
const computeDetailedCardsId = cardInfo => {
    const { scenario, workspace, id } = cardInfo;
    return `${scenario}_${workspace}_${id}`;
};
export const availableCards = createItemFetcher(availableCardsUrlCompute, "CARDS_GET_LIST", computeCardsId);
export const useAvailableCards = createUseFetch(availableCards, state => state.availableCards);
export const detailedCards = createItemFetcher(detailedCardsUrlCompute, "CARDS_GET_DETAILS", computeDetailedCardsId);
export const useDetailedCards = createUseFetch(detailedCards, state => state.detailedCards);
export const combinedCards = combineDucks({
    availableCards,
    detailedCards
});
//# sourceMappingURL=index.js.map